module.exports = __webpack_public_path__ + "static/media/view1.8b2dcbff.jpg";